import { FC, PropsWithChildren } from 'react';
import { Provider } from 'react-wrap-balancer';

export const BalanceProvider: FC<PropsWithChildren> = ({ children }) => {
  return <Provider>{children}</Provider>;
};
